"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContractCadence = void 0;
const react_graphql_1 = require("../../generated/react-graphql");
function prepareCadence(script, contractName, address) {
    return script
        .replaceAll("{contractName}", contractName)
        .replaceAll("{contractAddress}", address);
}
function useContractCadence({ nftAddress, niftoryAddress, registryAddress, clientId, }) {
    const [{ data, fetching }] = (0, react_graphql_1.useContractQuery)();
    const IS_ACCOUNT_CONFIGURED_SCRIPT = `
import NonFungibleToken from ${nftAddress}
import MetadataViews from ${nftAddress}
import NiftoryNonFungibleToken from ${niftoryAddress}
import NiftoryNFTRegistry from ${niftoryAddress}
import {contractName} from {contractAddress}
pub fun main(account: Address): Bool {
    let paths = NiftoryNFTRegistry.getCollectionPaths(${registryAddress}, "${clientId}_{contractName}")
    let acct = getAccount(account)
    return acct.getCapability<&{
        NonFungibleToken.Receiver,
        NonFungibleToken.CollectionPublic,
        MetadataViews.ResolverCollection,
        NiftoryNonFungibleToken.CollectionPublic
    }>(paths.public).check()
}`;
    const CONFIGURE_ACCOUNT_TRANSACTION = `
import NonFungibleToken from ${nftAddress}
import MetadataViews from ${nftAddress}
import NiftoryNonFungibleToken from ${niftoryAddress}
import NiftoryNFTRegistry from ${niftoryAddress}
import {contractName} from {contractAddress}

transaction {
    prepare(acct: AuthAccount) {
        let paths = NiftoryNFTRegistry.getCollectionPaths(${registryAddress}, "${clientId}_{contractName}")
        
        if acct.borrow<&NonFungibleToken.Collection>(from: paths.storage) == nil {
            let nftManager = NiftoryNFTRegistry.getNFTManagerPublic(${registryAddress}, "${clientId}_{contractName}")
            let collection <- nftManager.getNFTCollectionData().createEmptyCollection()
            acct.save(<-collection, to: paths.storage)

            acct.unlink(paths.public)
            acct.link<&{
                NonFungibleToken.Receiver,
                NonFungibleToken.CollectionPublic,
                MetadataViews.ResolverCollection,
                NiftoryNonFungibleToken.CollectionPublic
            }>(paths.public, target: paths.storage)

            acct.unlink(paths.private)
            acct.link<&{
                NonFungibleToken.Provider,
                NiftoryNonFungibleToken.CollectionPrivate
            }>(paths.private, target: paths.storage)
        }
    }
}`;
    const contract = data === null || data === void 0 ? void 0 : data.contract;
    let isAccountConfigured_script;
    let configureAccount_transaction;
    if (contract && !fetching) {
        const { name, address } = contract;
        isAccountConfigured_script = prepareCadence(IS_ACCOUNT_CONFIGURED_SCRIPT, name, address);
        configureAccount_transaction = prepareCadence(CONFIGURE_ACCOUNT_TRANSACTION, name, address);
    }
    return {
        isAccountConfigured_script,
        configureAccount_transaction,
        isLoading: fetching,
    };
}
exports.useContractCadence = useContractCadence;
